/*
 * @FilePath: \kitchen-online-web\src\utils\util.js
 * @Author: Yu Wang
 * @Date: 2021-07-09 09:53:02
 * @LastEditors: Yu Wang
 * @LastEditTime: 2022-06-13 13:53:48
 */
// 价格处理
export function priceSwitch(x) {
  // 强制保留两位小数
  let f = parseFloat(x);
  if (Number.isNaN(f)) return false;
  f = Math.round(x * 100) / 100;
  let s = f.toString();
  const rs = s.indexOf('.');
  if (rs < 0) {
    // rs = s.length;
    s += '.';
  }
  // while (s.length < (rs + 1) + 2) {
  //   s += '0';
  // }
  // 每三位用一个逗号隔开
  let leftNum = s.split('.')[0];
  const rightNum = `.${s.split('.')[1]}`;
  let result;
  // 定义数组记录截取后的价格
  const resultArray = [];
  if (leftNum.length > 3) {
    let i = true;
    while (i) {
      resultArray.push(leftNum.slice(-3));
      leftNum = leftNum.slice(0, leftNum.length - 3);
      if (leftNum.length < 4) {
        i = false;
      }
    }
    // 由于从后向前截取，所以从最后一个开始遍历并存到一个新的数组，顺序调换
    const sortArray = [];
    for (let j = resultArray.length - 1; j >= 0; j -= 1) {
      sortArray.push(resultArray[j]);
    }
    result = `${leftNum},${sortArray.join(',')}${rightNum}`;
  } else {
    result = s;
  }
  return result.replace('.', '');
}

// 价格转换   20000.00  =>  '20,000.00'   cutting=true的时候返回的是一个数组['20,000','.00']
export function priceFormate(price, cutting) {
  if (Number.isNaN(parseFloat(price, 10))) return false;
  const a = price.toString().split('.')[0];
  let b = price.toString().split('.')[1];
  if (b?.length === 1) {
    b *= 10;
  }
  if (cutting) {
    return [a.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'), `.${b || '00'}`];
  }
  return `${a.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')}.${b || '00'}`;
}

// 设置cookie
export function setCookie(name, value, day, path, domain) {
  const defaultDay = day || 30;
  const defaultPath = path || '/';
  let str = `${name}=${value}; `;
  if (defaultDay) str += `expires=${new Date(Date.now() + defaultDay * 24 * 3600 * 1000).toGMTString()}; `;
  if (defaultPath) str += `path=${defaultPath}; `;
  if (domain) str += `domain=${domain}`;
  document.cookie = str;
}

// 获取cookie
export function getCookie(name) {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

// 清除cookie
export function eraseCookie(name) {
  document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}

// 判断当前环境
export const PLATFORM = () => localStorage.getItem('currentPlatform');

// 冰箱反显
export function getrefrigerId(list) {
  const data = list.filter((i) => i.categoryId === 39);
  if (Object.keys(data).length !== 0) {
    if (data[0].width === 60) return 1;
    if (data[0].width === 100) return 2;
  }
  return 0;
}

// 获取把手groups
export function getHandgroups(list) {
  const handList = list.filter((i) => i.categoryName === '把手');
  if (Object.keys(handList).length !== 0) {
    return handList[0].frameId;
  }
  return undefined;
}

// 获取高柜的回显id
export function getHighId(list) {
  const handList = list.filter((i) => i.kitchenCategoryId === 10
  || i.kitchenCategoryId === 11 || i.kitchenCategoryId === 12);
  if (Object.keys(handList).length !== 0) {
    return true;
  }
  return false;
}

// 把手回显
export function initHand(handList, list) {
  const data = handList.filter((obj) => list.some((obj1) => obj1.frameId === obj.groups && obj1.categoryName === '把手'));
  if (Object.keys(data).length !== 0) {
    return data[0].groups;
  }
  return undefined;
}

// 高柜反显
export function initTallark(talllist, list) {
  const data = talllist.filter((obj) => list.some((obj1) => obj.id === obj1.kitchenCategoryId
  || obj.id === obj1.kitchenCategoryId || obj.id === obj1.kitchenCategoryId));
  if (Object.keys(data).length !== 0) {
    return data;
  }
  return [];
}

// 添加高柜对比抽屉减少数量
export function changeDrawerNum(list) {
  const drawerTwo = list.accessories?.filter((i) => i.kitchenCategoryId === 6);
  const drawerThree = list.accessories?.filter((i) => i.kitchenCategoryId === 5);
  const drawerFour = list.accessories?.filter((i) => i.kitchenCategoryId === 7);
  return drawerTwo.reduce((num, val) => num + val.quantity, 0)
  + drawerThree.reduce((num, val) => num + val.quantity, 0) + drawerFour.reduce((num, val) => num + val.quantity, 0);
}


// 二维数组转为一维数组
export const flatten = (arr) => [].concat(...arr.map((x) => (Array.isArray(x) ? flatten(x) : x)));

// 数组去重
export const removing = (arr) => [...new Set(arr)];

// 两个数组是否有交集
export const intersection = (arr1, arr2) => {
  const map = new Map();
  arr1.forEach((n) => {
    map.set(n, true);
  });
  const res = [];
  arr2.forEach((n) => {
    if (map.get(n)) {
      res.push(n);
      map.delete(n);
    }
  });
  return !!res.length;
};


/** ****
 * @description: 门板台面筛选逻辑
 * @param {*}: type -> 门板或台面 screenType -> 筛选类型  data -> 当前筛选值  lists -> 所有数据  other -> 其他筛选条件
 *             setPriceOption -> 设置价格的方法 setColorOption -> 设置颜色的方法 setMaterialOption -> 设置材质的方法
 * @return {*}
 */

export const screeningLogic = ({
  type = 'mesa',
  screenType,
  data,
  lists,
  other,
}, {
  setPriceOption,
  setColorOption,
  setMaterialOption,
}) => {
  // 因台面和门板api返回字段不一致所以判断设置字段
  const materialCode = type === 'mesa' ? 'typeCode' : 'materialType';
  const priceCode = type === 'mesa' ? 'priceLevel' : 'priceLadder';

  if (screenType === 'material') {
    if (data.length) { // 有材质筛选条件 设置其他两个筛选条件
      const filterMaterial = lists.filter((item) => data.includes(`${item[materialCode]}`));
      // 存在颜色条件时 设置价格选项
      if (other?.colorList.length) {
        const filterColors = filterMaterial.filter(
          (item) => intersection(other.colorList, item.colorCode),
        );
        setPriceOption(filterColors);
      } else { // 不存在颜色条件时
        setPriceOption(filterMaterial);
      }

      // 存在价格条件时 设置颜色选项
      if (other?.priceList.length) {
        const filterPrice = filterMaterial.filter(
          (item) => other.priceList.includes(`${item[priceCode]}`),
        );
        setColorOption(filterPrice);
      } else { // 不存在价格条件时
        setColorOption(filterMaterial);
      }
    } else { // 没有材质筛选条件 设置其他两个筛选条件
      // 存在颜色条件时 设置价格选项
      if (other?.colorList.length) {
        const filterColors = lists.filter(
          (item) => intersection(other.colorList, item.colorCode),
        );
        setPriceOption(filterColors);
      } else { // 不存在颜色条件时
        setPriceOption([], false);
      }
      // 存在价格条件时 设置颜色选项
      if (other?.priceList.length) {
        const filterPrice = lists.filter((item) => other.priceList.includes(`${item[priceCode]}`));
        setColorOption(filterPrice);
      } else { // 不存在价格条件时
        setColorOption(lists);
      }
      if (other?.priceList.length === 0 && other?.colorList.length === 0) {
        setMaterialOption([], false);
      }
    }
  } else if (screenType === 'color') {
    if (data.length) { // 有颜色筛选条件 设置其他两个筛选条件
      const filterColor = lists.filter((item) => intersection(data, item.colorCode));
      // 存在价格条件时 设置材质选项
      if (other?.priceList.length) {
        const filterPrice = filterColor.filter((item) => other.priceList.includes(`${item[priceCode]}`));
        setMaterialOption(filterPrice);
      } else { // 不存在价格条件时
        setMaterialOption(filterColor);
      }

      //  存在材质条件时 设置价格选项
      if (other?.materialList.length) {
        const filterMaterial = filterColor.filter(
          (item) => other.materialList.includes(`${item[materialCode]}`),
        );
        setPriceOption(filterMaterial);
      } else {
        setPriceOption(filterColor);
      }
    } else { // 没有颜色筛选条件 设置其他两个筛选条件
      // 存在价格条件时 设置材质选项
      if (other?.priceList.length) {
        const filterPrice = lists.filter((item) => other.priceList.includes(`${item[priceCode]}`));
        setMaterialOption(filterPrice);
      } else { // 不存在价格条件时
        setMaterialOption([], false);
      }

      //  存在材质条件时 设置价格选项
      if (other?.materialList.length) {
        const filterMaterial = lists.filter(
          (item) => other.materialList.includes(`${item[materialCode]}`),
        );
        setPriceOption(filterMaterial);
      } else {
        setPriceOption([], false);
      }

      if (other?.priceList.length === 0 && other?.materialList.length === 0) {
        setColorOption([]);
      }
    }
  } else if (screenType === 'price') {
    if (data.length) { // 有价格筛选条件 设置其他两个筛选条件
      const filterPrice = lists.filter((item) => data.includes(`${item[priceCode]}`));
      //  存在材质条件时 设置颜色选项
      if (other?.materialList.length) {
        const filterMaterial = filterPrice.filter(
          (item) => other.materialList.includes(`${`${item[materialCode]}`}`),
        );
        setColorOption(filterMaterial);
      } else {
        setColorOption(filterPrice);
      }

      // 存在颜色条件时 设置材质选项
      if (other?.colorList.length) {
        const filterColors = filterPrice.filter(
          (item) => intersection(other.colorList, item.colorCode),
        );
        setMaterialOption(filterColors);
      } else { // 不存在颜色条件时
        setMaterialOption(filterPrice);
      }
    } else { // 没有价格筛选条件 设置其他两个筛选条件
      //  存在材质条件时 设置颜色选项
      if (other?.materialList.length) {
        const filterMaterial = lists.filter(
          (item) => other.materialList.includes(`${item[materialCode]}`),
        );
        setColorOption(filterMaterial);
      } else {
        setColorOption(lists);
      }

      // 存在颜色条件时 设置材质选项
      if (other?.colorList.length) {
        const filterColors = lists.filter(
          (item) => intersection(other.colorList, item.colorCode),
        );
        setMaterialOption(filterColors);
      } else { // 不存在颜色条件时
        setMaterialOption([], false);
      }
      if (other?.materialList.length === 0 && other?.colorList.length === 0) {
        setPriceOption([], false);
      }
    }
  }
};

export const domScrollGesture = (element, callback) => {
  function getScrollTop() {
    let scrollTop = 0;
    if (element.scrollTop) {
      scrollTop = element.scrollTop;
    }
    return scrollTop;
  }
  let scrollTop = 0; let topValue = getScrollTop();
  let scrollUpSign = false;
  let scrollDownSign = false;
  document.getElementById('content-container').addEventListener('scroll', () => {
    let gesture = '';
    scrollTop = getScrollTop();
    if ((element.scrollHeight - element.scrollTop - element.offsetHeight) > 20 && getScrollTop() > 20) {
      if (scrollTop <= topValue) {
        if (!scrollUpSign) {
          gesture = 'down';
          scrollUpSign = true;
          scrollDownSign = false;
          callback(gesture);
        }
      } else if (!scrollDownSign) {
        gesture = 'up';
        callback(gesture);

        scrollDownSign = true;
        scrollUpSign = false;
      }
      setTimeout(() => { topValue = scrollTop; }, 0);
    }
  });
};
export function storeLeadsInfo() {
  const serilizeUrl = () => {
    let url = window.location.search;// url中?之后的部分
    if (sessionStorage.getItem('source')) {
      return { source: 'leads' };
    }
    url = url.substring(1);// 去掉?剩下的都为a=b&c=d&e=f...模式
    const dataObj = {};
    if (url.indexOf('&') > -1) {
      url = url.split('&');// url中去掉&全部变成“a=b” “c=d” “e=f”的模式
      console.log(`去掉&的url...${url}`);
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < url.length; i++) {
        const arr = url[i].split('=');
        console.log(`以=分割的代码....${arr}`);
        // eslint-disable-next-line prefer-destructuring
        dataObj[arr[0]] = arr[1];
        console.log(`dataObj...${dataObj}`);
      }
    } else {
      url = url.split('=');
      // eslint-disable-next-line prefer-destructuring
      dataObj[url[0]] = url[1];
    }
    return dataObj;
  };
  // 存referrer,reload的时候不存
  const params = serilizeUrl();
  // console.log('params', params);
  if (params?.source === 'leads' && !sessionStorage.getItem('referrer')) {
    console.log(process.env.REACT_APP_LEADS_HOST);
    sessionStorage.setItem('referrer', process.env.REACT_APP_LEADS_HOST);
    sessionStorage.setItem('source', 'leads');
  }

  return params;
}

export function convertHTypeToIIType(type) {
  if (type === 'H') {
    return 'II';
  }
  if (type === 'U_S') {
    return 'U';
  }
  return type;
}
